module.exports = __webpack_public_path__ + "media/images/icons/frowny-0f1e1000a3f27947a18bd2ccd428a48e.svg";